var map = {
	"./icon-dock-placeholder.svg": "8bca",
	"./icon-elearning.svg": "88ad",
	"./icon-facebook.svg": "9c81",
	"./icon-live.svg": "b761",
	"./icon-snapchat.svg": "5aff",
	"./icon-tiktok.svg": "8f1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";